var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMagnifyingGlassPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#e3e1e1",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 491.521 491.521",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M489.573,427.178L365.638,303.242l-62.395,62.395l123.936,123.935c2.597,2.597,6.805,2.597,9.403,0l52.992-52.992 C492.17,433.984,492.17,429.776,489.573,427.178z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M349.145,286.75l-21.654-21.654c-2.597-2.597-6.806-2.597-9.403,0l-9.794,9.794l-17.223-17.222 c47.035-63.239,42.041-152.973-15.345-210.36c-63.077-63.077-165.343-63.077-228.419,0c-63.075,63.076-63.076,165.342,0,228.418 c57.388,57.386,147.123,62.381,210.361,15.345l17.223,17.222l-9.795,9.795c-2.596,2.597-2.596,6.805,0.001,9.402l21.653,21.655 l5.283,5.282l62.395-62.395L349.145,286.75z M248.649,248.65c-48.151,48.151-126.219,48.151-174.372,0 c-48.151-48.151-48.15-126.22,0.002-174.371c48.151-48.152,126.219-48.152,174.37,0 C296.801,122.43,296.802,200.498,248.649,248.65z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-95, -10)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 165,
    width: 160,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 95,
    width: 20,
    height: 160
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlassPlus);
export default __webpack_public_path__ + "static/media/magnifying-glass-plus.55666ca90f3ead865c3fbba98ff11212.svg";
export { ForwardRef as ReactComponent };